module.exports = __webpack_public_path__ + "static/p1-e6a2429bc441a35289d9e0e893ffe1e8.jpg";